import React from "react";
import CustomInput from "../../../ui/custom-inputs/CustomInput";
import { useFormik } from "formik";

function ManageTrendingFilter({setFilterApply, setSkip}) {

  const {
    values: searchValues,
    handleBlur: seacrhHandleBlur,
    handleChange: seacrhHandleChange,
  } = useFormik({
    initialValues: {
      filter: "",
    },
  });
  
  const handleSearch = () => {
    setSkip(0)
    setFilterApply(searchValues);
  };
  
  return (
    <div className='d-flex justify-content-between align-items-start'>
      <div className='form-group mb-3' style={{ flex: 1, marginRight: "1rem" }}>
        <CustomInput
          withFocus={true}
          placeholder='Name'
          id='filter'
          name='filter'
          type='text'
          value={searchValues?.filter}
          onChange={seacrhHandleChange}
          onBlur={seacrhHandleBlur}
        />
      </div>
      <button
        class='btn btn-danger px-5 py-2 rounded-pill'
        style={{ height: "fit-content" }}
        type='button'
        onClick={handleSearch}
      >
        Search
      </button>
    </div>
  );
}

export default ManageTrendingFilter;
